import React from 'react';
import { LanguageModel } from '../../../../../models';
import { ReportItem } from '../MenuItem'; // El componente que creamos para los items de reporte
import { Periods } from '../../../../../constants';

interface Props {
    langResources: LanguageModel;
    handlerSaveReportByPeriod: (
        period: number,
        periodName: string,
        name: string,
        url: string
    ) => void;
}

export const CostCenterMenuGroup: React.FC<Props> = ({
    langResources,
    handlerSaveReportByPeriod,
}) => {
    const reportPeriods = [
        {
            period: Periods.WEEKLY,
            label: langResources['header.reports.weekly'],
            name: 'Semanal',
        },
        {
            period: Periods.BIWEEKLY,
            label: langResources['header.reports.biweekly'],
            name: 'Quincenal',
        },
        {
            period: Periods.MONTHLY,
            label: langResources['header.reports.monthly'],
            name: 'Mensual',
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>{langResources['header.reports.cost.center.item']}</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-4'>
                    {reportPeriods.map(({ period, label, name }) => (
                        <ReportItem
                            key={period}
                            label={label}
                            handler={() =>
                                handlerSaveReportByPeriod(
                                    period,
                                    name,
                                    'Centro de Costo',
                                    'cost-centers-by-period'
                                )
                            }
                        />
                    ))}
                </ul>
            </div>
        </li>
    );
};
